import React from "react";
import { Typography, Paper } from "@mui/material";
import { Person as PersonIcon } from "@mui/icons-material";
import DataTable from "../DataTable";
import { formatCurrency } from "../../utils/formatters";

const TrainerCostsTable = ({ trainerCosts, isMobile }) => (
  <Paper sx={{ p: 3, mb: 3 }}>
    <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, display: 'flex', alignItems: 'center' }}>
      <PersonIcon sx={{ mr: 1 }} />
      Koszty trenerów ({trainerCosts?.length || 0})
    </Typography>
    <DataTable
      size={isMobile ? "small" : "medium"}
      rows={trainerCosts}
      getRowKey={(row, index) => index}
      columns={[
        {
          key: "name",
          label: "Trener",
          render: (row) => <Typography variant="body2" sx={{ fontWeight: 500 }}>{row.name}</Typography>,
        },
        {
          key: "lesson_count",
          label: "Liczba zajęć",
          align: "right",
          render: (row) => <Typography variant="body2">{row.lesson_count}</Typography>,
        },
        {
          key: "hourly_cost",
          label: "Stawka/godz.",
          align: "right",
          render: (row) => (
            <Typography variant="body2">{row.hourly_cost > 0 ? formatCurrency(row.hourly_cost) : '-'}</Typography>
          ),
        },
        {
          key: "total_cost",
          label: "Łączny koszt",
          align: "right",
          render: (row) => (
            <Typography variant="body2" sx={{ fontWeight: 600, color: '#f093fb' }}>
              {formatCurrency(row.total_cost)}
            </Typography>
          ),
        },
      ]}
    />
  </Paper>
);

export default TrainerCostsTable;
